import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ActionSheet, ActionSheetController, Config, NavController, ToastController } from 'ionic-angular';

import { BlockingtimeData } from '../../providers/blockingtime-data';
import { BlockingtimeDetailPage } from './blockingtime-detail';
import { BlockingtimeCreatePage } from './blockingtime-create';
import { UserData } from '../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

import { localeDe } from '../../providers/aggridlocale.de'

import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';
import moment from 'moment';

@Component({
  selector: 'blockingtime-list',
  templateUrl: 'blockingtime-list.html'
})
export class BlockingtimeListPage {
  @ViewChild('blockingtimeGrid') agGrid: AgGridAngular;
  rowDataBlockingtimes:any;
  columnDefsBlockingtimes:any;
  gridOptionsBlockingtimes:any;
  searchQuery: string;
  bFilterActive: boolean;
  modules: Module[] = AllModules;

  actionSheet: ActionSheet;
  blockingtime = [];
  viewmode = "planned";
  constructor( public common: CommonData
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , public http: Http
              , public blockingtimeData: BlockingtimeData
              , public config: Config
              , public userData: UserData
              , public alertCtrl: AlertController
              ){
        blockingtimeData.viewmode = this.viewmode;
        blockingtimeData.updateRequired = true; 

        this.bFilterActive = false;
        /*
        if(this.userData.usergroup_id == 1){
          this.columnDefsBlockingtimes = [
            {
              headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
            }
    
          ];      
          
        }
        else{
          this.columnDefsBlockingtimes = [];           
        }
        */
        this.columnDefsBlockingtimes = [];  
      /*        
        this.columnDefsBlockingtimes.push(
          {headerName: "Grundstuecke (Gross-/Kleinschr. beachten)", field: "attributes.grundstuecknamen", resizable: true, width:400, filter: 'agTextColumnFilter', filterParams:{
            filterOptions:['contains', 'notContains'],
            textFormatter: function(r){
                if (r==null) return null;
      
                return r;
            },
            debounceMs:0,
            caseSensitive:true,
            suppressAndOrCondition:true
          }}
        );
    */
        //this.columnDefsBlockingtimes.push({headerName: 'Archiviert', field: 'archiviert', resizable: true, width:120 , valueGetter: this.archiviertTextValueGetter.bind(this)  });
        this.columnDefsBlockingtimes.push({headerName: 'Typ', field: 'informationonly', resizable: true, width:250, valueGetter: this.typTextValueGetter.bind(this)   });      
        this.columnDefsBlockingtimes.push({headerName: 'Start', field: 'begin', sort: 'asc' , resizable: true,  filter: "agDateColumnFilter",
        browserDatePicker:true,
        filterParams: {
          filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            
              if (cellValue === null) return -1;
              let cellDate = moment(cellValue).toDate();
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
        },
          browserDatePicker: true
      }
      });
        this.columnDefsBlockingtimes.push({headerName: 'Ende', field: 'end',  resizable: true, filter: "agDateColumnFilter",
        browserDatePicker:true,
        filterParams: {
          filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            
              if (cellValue === null) return -1;
              let cellDate = moment(cellValue).toDate();
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
        },
          browserDatePicker: true
      }
      });
      
      this.columnDefsBlockingtimes.push({headerName: 'Erfasst durch', field: 'username', resizable: true, width:150 });
      this.columnDefsBlockingtimes.push({headerName: 'Beschreibung', field: 'description', filter: false, resizable: true, width:250 });
      this.columnDefsBlockingtimes.push({headerName: 'Grundstücke', field: 'pp', filter: false, resizable: true, width:250, valueGetter: this.ppTextValueGetter.bind(this)   });      
      
        
      this.gridOptionsBlockingtimes = {         
        localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,       
        isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
        doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
        onGridReady: this.gridReady.bind(this),
        onFilterChanged: this.filterChanged.bind(this),
        
        floatingFilter: true,
        defaultColDef : {
          filter:true,
          sortable: true
        }
      }

        
      // get filter instance
      
      //const informationonlyFilterComponent = this.gridOptionsBlockingtimes.api.getFilterInstance('informationonly'); 
      
      // get filter model
      //const model = informationonlyFilterComponent.getModel(); 
      /*
      // set filter model and update
      informationonlyFilterComponent.setModel({dateFrom: "2023-09-20", dateTo: null, filterType: "date", type:"greaterThanOrEqual"});

      // refresh rows based on the filter (not automatic to allow for batching multiple filters)
      this.gridOptionsBlockingtimes.api.onFilterChanged();
      */
  }

  firstDataRendered(event){
    this.defaultFilter();
  }
  defaultFilter(){

    //console.log("defaultFilter");
    var filterComponent = this.agGrid.api.getFilterInstance('end');
   
    // get filter model    
    //filterComponent.setModel({dateFrom: "2023-09-20", dateTo: null, filterType: "date", type:"greaterThanOrEqual"});
    //this.agGrid.api.onFilterChanged();
  }  

  ionViewWillEnter() {
    if(this.blockingtimeData.updateRequired){
      Promise.all([    
          this.blockingtimeData.load(),            
        ]).then(data => {
          //console.log(this.blockingtimeData.data);
          this.rowDataBlockingtimes = this.blockingtimeData.data;           
        });

    }
  }  

  doRefresh(refresh){
        this.blockingtimeData.viewmode = this.viewmode;
        Promise.all([
            this.blockingtimeData.load(),            
          ]).then(data => {
            //console.log(data);
            //console.log(this.blockingtimeData.data);
            this.rowDataBlockingtimes = this.blockingtimeData.data;           
            //refresh.complete();     
          });    
    
  }  
  
  addBlockingtime() {
    if(!this.common.wifierror){
      this.navCtrl.push(BlockingtimeCreatePage, {},{animate: true, animation: 'ios-transition'});
    }
    else{
      this.common.showWifiError(); 
    }
  }
  showDetail(selectedRecord) {
    if(!this.common.wifierror){
      this.navCtrl.push(BlockingtimeCreatePage, selectedRecord,{animate: true, animation: 'ios-transition'});
    }
    else{
      this.common.showWifiError(); 
    }
  }
  confirmDelete(bt){
     let title = "";
     let param: any;
      
      title = "Soll die Sperrzeit '"+bt.description+"' gelöscht werden?";
      //param = {pp : bt.pp};
      //console.log(bt.btids);
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.addButton({
        text: 'Ja, löschen',
        handler: (data: any) => {
            
            Promise.all([
                this.blockingtimeData.delete(bt.btids),            
              ]).then(data => {
                this.doRefresh(event);
              });            
            //this.testCheckboxOpen = false;
        }
      });
      alert.addButton('Nein');

      alert.present();
      
   
  }



  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node) {
    return true;
  }  

  filterItems(ev: any) {
    this.searchGrid(ev);

  }     
  searchGrid(event){
    this.gridOptionsBlockingtimes.api.setQuickFilter(this.searchQuery);
  }  

  gridRowDblClicked(event: any){ 
    this.showDetail(event.data)
  }

  gridClearFilter(){

    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }    

  ppTextValueGetter(params) {

    return params.data.pp.map(function(elem){ 
      return elem.kurzname 
    })
    .join(",");

  }

  typTextValueGetter(params) {
    
    if(params.data.informationonly == 1){
      return "Info";
    }
    else{
      return "Keine Kontrolle";
    }
  }
  gridReady(event){
    
    //this.loadFilters();
  }
  filterChanged(event){
    
    var model = this.agGrid.gridOptions.api.getFilterModel();

  }



}



// WEBPACK FOOTER //
// ./src/pages/blockingtime/blockingtime-list.ts